import * as sessionService from 'utils/services/sessions';
import { notification } from 'antd';
import * as types from '../../types/eventScheduleTypes';

const regenerateUrlBegin = () => {
  return {
    type: types.REGENERATE_MICROSOFT_SESSION_LINK_BEGIN
  }
}

const regenerateUrlSuccess = () => {
  return {
    type: types.REGENERATE_MICROSOFT_SESSION_LINK_SUCCESS
  }
}

const regenerateUrlError = () => {
  return {
    type: types.REGENERATE_MICROSOFT_SESSION_LINK_ERROR
  }
}


const handleRegenerateSessionUrl = (sessionId, cb = () => {}) => {
  return async dispatch => {
    await dispatch(regenerateUrlBegin())
    try {
      await sessionService.regenerateSessionUrl(sessionId);
      await dispatch(regenerateUrlSuccess());
      cb();
      notification.success({
        message: 'Success',
        description: 'New Microsoft Teams Link Generated',
      });
    } catch(err) {
      notification.error({
        message: 'Error',
        description: 'Error Generating the Microsoft Teams Link',
      });
      await dispatch(regenerateUrlError())
      throw err;
    }
  }

}

export default handleRegenerateSessionUrl;